import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';
import { FranchiseFeatureType } from '../franchises/type';

const ReferralAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  featureRestriction: FranchiseFeatureType.GAME,
  routes: [
    {
      path: routesUrl.referralTiers,
      exact: true,
      component: React.lazy(() => import('./pages/ReferralTiersPage')),
    },
    {
      path: routesUrl.referral,
      exact: true,
      component: React.lazy(() => import('./pages/ReferralPage')),
    },
  ],
};

export default ReferralAppConfig;
